import thumbnail from "../../../assets/images/projects/maudi/iceberg.png";
import { ProjectDataProps } from "../props";

export default {
  title: "Reframing Mobile Web for Global Travelers",
  description:
    "How I led an audit to make mobile web clearer and more trustworthy for travelers beyond Southeast Asia.",
  image: thumbnail,
  path: "/traveloka-maudi",
  thumbnailBackground: "radial-gradient(circle at 50% 18%, #174d65 0%, #0d2f40 46%, #071d29 100%)",
  thumbnailFit: "contain",
  thumbnailPosition: "center",
  thumbnailScale: 0.84,
} as ProjectDataProps;
